import ReturnToApp from '../../../settings/ReturnToApp';
import Users from '../../../settings/Users';
import UserProfile from '../../../settings/UserProfile';
import CompanyProfile from '../../../settings/CompanyProfile';
import Notifications from '../../../settings/Notifications';
import Releases from '../../../settings/Releases';
import Admin from '../../../settings/Admin/Applications';
import Category from '../../../settings/Admin/Category';

//-- private is a reserved word, so use secured instead

const settingsRoutes = [
	{
		id: 'settings-return-to-app',
		name: 'settings-return-to-app',
		paths: ['/settings-return-to-app'],
		exact: true,
		component: ReturnToApp,
		meta: {
			enabled: true,
			secured: true,
			roles: [],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Return to app',
			icon: <i className='las la-undo'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-user-profile',
		name: 'settings-user-profile',
		paths: ['/settings-user-profile'],
		exact: true,
		component: UserProfile,
		meta: {
			enabled: true,
			secured: true,
			roles: [],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Profile',
			icon: <i className='las la-id-card'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-users',
		name: 'settings-users',
		paths: ['/settings-users'],
		exact: true,
		component: Users,
		meta: {
			enabled: true,
			secured: true,
			roles: ['EntDevAdmin', 'Admin'],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Users',
			icon: <i className='las la-user-friends'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-company-profile',
		name: 'settings-company-profile',
		paths: ['/settings-company-profile'],
		exact: false,
		component: CompanyProfile,
		meta: {
			enabled: true,
			secured: true,
			roles: ['EntDevAdmin', 'CompanyAdmin'],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Company Profile',
			icon: <i className='las la-building'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-notifications',
		name: 'settings-notifications',
		paths: ['/settings-notifications'],
		exact: true,
		component: Notifications,
		meta: {
			enabled: true,
			secured: true,
			roles: ['EntDevAdmin'],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Notifications',
			icon: <i className='las la-comment'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-releases',
		name: 'settings-releases',
		paths: ['/settings-releases'],
		exact: true,
		component: Releases,
		meta: {
			enabled: true,
			secured: true,
			roles: [],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Releases',
			icon: <i className='las la-code-branch'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	},
	{
		id: 'settings-admin',
		name: 'settings-admin',
		paths: ['/settings-admin'],
		exact: true,
		component: null,
		meta: {
			enabled: true,
			secured: true,
			roles: ['EntDevAdmin'],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Admin',
			icon: <i className='las la-tools'></i>,
			level: 1,
			children: [
				{
					id: 'settings-app',
					name: 'settings-app',
					paths: ['/settings-app'],
					exact: true,
					component: Admin,
					meta: {
						enabled: true,
						secured: true,
						roles: ['EntDevAdmin'],
						showInNav: true,
						showBreadcrumb: true,
						linkText: 'App Management',
						icon: <i className='las la-rocket'></i>,
						level: 2,
						children: null,
						signIn: false,
						signOut: false,
						authCallback: false,
						setupRequired: false,
						unauthorized: false,
						loginFailed: false,
						httpError: false,
						pageNotFound: false,
						home: false,
						content: false,
						settings: true
					}
				},
				{
					id: 'settings-category',
					name: 'settings-category',
					paths: ['/settings-category'],
					exact: true,
					component: Category,
					meta: {
						enabled: true,
						secured: true,
						roles: ['EntDevAdmin'],
						showInNav: true,
						showBreadcrumb: true,
						linkText: 'Category Management',
						icon: <i className='las la-list'></i>,
						level: 2,
						children: null,
						signIn: false,
						signOut: false,
						authCallback: false,
						setupRequired: false,
						unauthorized: false,
						loginFailed: false,
						httpError: false,
						pageNotFound: false,
						home: false,
						content: false,
						settings: true
					}
				}
			],
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: false,
			settings: true
		}
	}
];

export default settingsRoutes;
